import { Action } from 'infra/types'
import { DUE_CONFIG, LIST_USAGE_TYPE } from 'services/Api/StaffLinkApiFolder/type'
import { ISaleAllocations, ISaleAssignments } from 'state/new-summary/list/list.types'
import { ICreateNewListState } from 'state/new-summary/root-drawers/create-new-list/create-new-list.types'

export const createNewListDrawerActions = {
  SET_CREATE_NEW_LIST_DRAWER: 'createNewList/setCreateNewListDrawer',
  SET_UPDATE_LIST_DRAWER: 'createNewList/setUpdateListDrawer',
  RESET_CREATE_NEW_LIST_DRAWER: 'createNewList/resetCreateNewListState',
  SHOW_LIST_CUSTOMER_FOR_ORDER_SETTING: 'createNewList/showListCustomerForOrderSetting',
  SET_ALL_SETTINGS_DRAWERS_ACTION: 'createNewList/SET_ALL_SETTINGS_DRAWERS_ACTION',
  UPDATE_INVENTORY_ASSIGNMENT_ACTION: 'createNewList/UPDATE_INVENTORY_ASSIGNMENT_ACTION',
  SAVE_ACTIVE_SALE_ASSIGNMENT: 'createNewList/SAVE_ACTIVE_SALE_ASSIGNMENT',
  SAVE_SALE_ALLOCATION: 'createNewList/SAVE_SALE_ALLOCATION',
  SET_ALLOCATION_LIST_LOADERS: 'createNewList/SET_ALLOCATION_LIST_LOADERS'
}

export const setCreateNewListDrawer = (payload: {
  drawerStatus: boolean
  newListName?: string
}): Action<{ drawerStatus: boolean; newListName?: string }> => {
  return {
    type: createNewListDrawerActions.SET_CREATE_NEW_LIST_DRAWER,
    payload
  }
}

export const resetCreateNewListState = () => {
  return {
    type: createNewListDrawerActions.RESET_CREATE_NEW_LIST_DRAWER
  }
}

export const setUpdateListDrawer = (payload: {
  drawerStatus: boolean
  existingUsageType: LIST_USAGE_TYPE
  existingListName: string
  existingListType: DUE_CONFIG
  isClearAndAdd?: boolean
}): Action<{
  drawerStatus: boolean
  existingUsageType: LIST_USAGE_TYPE
  existingListName: string
  existingListType: DUE_CONFIG
  isClearAndAdd?: boolean
}> => {
  return {
    type: createNewListDrawerActions.SET_UPDATE_LIST_DRAWER,
    payload
  }
}

export const showListCustomerForOrderSettingAction = (payload: {
  isShowCustomerListForOrderSetting: boolean
  labelFilterAccountIds?: string[]
}): Action<{ isShowCustomerListForOrderSetting: boolean; labelFilterAccountIds?: string[] }> => {
  return {
    type: createNewListDrawerActions.SHOW_LIST_CUSTOMER_FOR_ORDER_SETTING,
    payload
  }
}

export const setCreateNewListDrawerAction = (payload: {
  id: keyof ICreateNewListState['drawers']
  value: boolean
}): Action<{
  id: string
  value: boolean
}> => ({
  type: createNewListDrawerActions.SET_ALL_SETTINGS_DRAWERS_ACTION,
  payload
})

export const handleAssignedInventoriesAction = (payload: {
  newItemIds: string[]
  removedItemIds: string[]
  listId: string
}): Action<{ newItemIds: string[]; removedItemIds: string[]; listId: string }> => ({
  type: createNewListDrawerActions.UPDATE_INVENTORY_ASSIGNMENT_ACTION,
  payload
})

export const saveActiveSaleAssignmentAction = (payload: {
  activeAssignment: ISaleAssignments | undefined
}): Action<{ activeAssignment: ISaleAssignments | undefined }> => ({
  type: createNewListDrawerActions.SAVE_ACTIVE_SALE_ASSIGNMENT,
  payload
})

export const saveSaleAllocationAction = (payload: {
  saleAllocations: ISaleAllocations[]
}): Action<{ saleAllocations: ISaleAllocations[] }> => ({
  type: createNewListDrawerActions.SAVE_SALE_ALLOCATION,
  payload
})

export const setAllocationDrawersAction = (payload: {
  loaderName: keyof ICreateNewListState['loaders']
  status: boolean
}): Action<{
  loaderName: keyof ICreateNewListState['loaders']
  status: boolean
}> => ({
  type: createNewListDrawerActions.SET_ALLOCATION_LIST_LOADERS,
  payload
})
